import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import TaskList from "./pages/TaskList";
import KanbanBoard from "./pages/KanbanBoard";
import AppShell from "./components/AppShell";
import PWAInstallPrompt from "./components/PWAInstallPrompt";

function App() {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("taskcommand_user");
    return saved ? JSON.parse(saved) : null;
  });

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem("taskcommand_user", JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("taskcommand_user");
  };

  if (!user) {
    return (
      <>
        <LoginPage onLogin={handleLogin} />
        <PWAInstallPrompt />
        <Toaster position="top-right" richColors />
      </>
    );
  }

  return (
    <BrowserRouter>
      <AppShell user={user} onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/tasks" element={<TaskList />} />
          <Route path="/kanban" element={<KanbanBoard />} />
        </Routes>
      </AppShell>
      <PWAInstallPrompt />
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
